<template>
  <div v-if="item">
    <!-- <fields-list :item="item" :fields="fields" /> -->
    <div >
      <div v-for="dFilter in dateFilter" :key="dFilter.key">
        <label>{{dFilter.title}} <span v-show="params[dFilter.key]" @click="params[dFilter.key]=null" class="link">сбросить</span></label>
        <datetime  v-model="params[dFilter.key]"  @input="params['page'] = 1"  class="from-control"  type="date" format="dd/MM/yyyy"></datetime> 
      </div>
      <template v-if="params.from && params.to">
        <blob-download :params="params" :url="`/users/${this.id}/tp-prods`" :name="item.name" class="m-y-2">Выгрузить</blob-download>
      </template>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "users",
    cardSetLink: "users",
    urlDownload: "",
    item: null,
    params: {},
    dateFilter:[
      {
        key:'from',
        title:'Начало даты',
      },
      {
        key:'to',
        title:'Конец даты',
      },
    ],
  }),
  props: ["id"],
  async created() {
    // this.pushLang();
    this.urlDownload = `/users/${this.id}/tp-prods`
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
   
    },
  },
};
</script>
<style>
</style>
